import { useEffect, useReducer, useState } from 'react';
import { useHome, useLifeHome } from 'all-in-one-shared-api';

import { useKeycloakReady } from 'hooks';

import { HomeContext, initialUserAccessValues, initialLifeHomeValues } from './context';
import { reducer, lifeHomeReducer } from '../home/reducer';
import { UserAccessActionTypes, lifeHomeActionTypes } from './actions';

interface HomeContextProviderProps {
  children: JSX.Element | JSX.Element[];
  loadFromStorage?: boolean;
}

const HomeContextProvider = ({ children }: HomeContextProviderProps) => {
  const [state, dispatch] = useReducer(reducer, initialUserAccessValues);
  const { ready, token, tokenParsed } = useKeycloakReady();
  const { shouldFetch, data, mutate } = useHome('useHome', token ?? '');
  const [lifeState, lifeDispatch] = useReducer(lifeHomeReducer, initialLifeHomeValues);
  const {
    data: LifeHomeData,
    shouldFetch: shouldFetchLifeHome,
    mutate: mutateLifeHome,
  } = useLifeHome(token ?? '', 'useLifehome', 'Y');
  const [showTips, setShowTips] = useState(true);

  useEffect(() => {
    if (tokenParsed?.ebClientKey) {
      shouldFetch(ready);
    }
    if (tokenParsed?.ilClientKey) {
      shouldFetchLifeHome(ready);
    }
  }, [shouldFetch, ready, tokenParsed, shouldFetchLifeHome]);

  useEffect(() => {
    if (data) {
      // Remove the following, once values have been added to useHome endpoint
      const mockResponseForDevelopment = {
        isFindDoctorEnabled: true,
        isViewMembershipCardEnabled: true,
        notificationCount: 0,
      };
      const userAccess = {
        ...mockResponseForDevelopment,
        ...data,
      };
      dispatch({
        type: UserAccessActionTypes.REFRESH,
        payload: { userAccess: userAccess },
      });
    }
  }, [data]);
  useEffect(() => {
    if (LifeHomeData) {
      lifeDispatch({
        type: lifeHomeActionTypes.REFRESH,
        payload: LifeHomeData,
      });
    }
  }, [LifeHomeData]);

  return (
    <HomeContext.Provider
      value={{ state, dispatch, mutate, showTips, setShowTips, lifeState, lifeDispatch, lifeMutate: mutateLifeHome }}
    >
      {children}
    </HomeContext.Provider>
  );
};

export { HomeContext, HomeContextProvider };
